module.exports = __webpack_public_path__ + "img/课堂实训.72d823da.svg";